import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
//import 'rxjs/add/operator/toPromise';
import { BaseService } from '../shared-service/base.service';
import { AuthOIDCService } from '../auth/authOIDC.service';
import { WindowRef } from '../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Injectable()
export class DataService {

	constructor(
		private router: Router, 
		private http: HttpClient, 
		private bs: BaseService,
		private authOIDCService: AuthOIDCService,
		private winRef:WindowRef
	) {
		this.dataStore = [];
	}

	dataStore: Object | any = {};
	chkSessionCntr: number = 0;
	sessionTimeout: number | null = null;
	LastRequestTime: Date | null = null;
	startTimer(sessionTimeout: number) {
		this.sessionTimeout = sessionTimeout;
		setInterval(() => {
			this.chkSessionCntr = this.chkSessionCntr + 1;
			if (this.chkSessionCntr > this.sessionTimeout!) {
				this.bs.logout();
			}
		}, 1000);
	}

	getDataStoreData(key: PropertyKey) {

		if (this.dataStore.hasOwnProperty(key)) {
			return this.dataStore[key];
		} else {
			return false;
		}
	};

	setStoreData(key: PropertyKey, updateData: Object) {
		this.dataStore[key] = updateData;
		return true;
	};

	appendHeaderIfUserLoggedIn() {

		if (this.dataStore.hasOwnProperty(this.bs.config.storageLoginKey)) {
			let obj = {
				headers: new HttpHeaders().set('Authorization', 'Bearer '.concat(this.authOIDCService.token?this.authOIDCService.token:'')),
			};
			return obj;
		}
		return;
	};
	showPreloader() {

		var screenHeight = this.winRef.nativeWindow.document.body.clientHeight;

		var screenWidth = this.winRef.nativeWindow.document.body.clientWidth;
		$(".preloader-overlay").css("height", screenHeight + "px");

		$(".preloader-overlay").show();
		$(".preloader").show();

		$(this.winRef.nativeWindow.document).scrollTop(0);
	}
	hidePreloader() {
		$(".preloader-overlay").hide();
		$(".preloader").hide();

		$(this.winRef.nativeWindow.document).scrollTop(0);
	}
	//function to extend user session of wizdom web

	postExtendSessionRequest() {
		
		let URL = this.bs.config.lmsBaseUrl + "Control/Controller.aspx?Action=forward/extendSession";

		$.ajax({
			type: 'POST',
			async: true,
			url: URL,
			data: '',
			success: (data:any) => {
				this.chkSessionCntr = 0;
			},
			error: (xhr:any, textStatus:any, errorThrown:any) => {
				this.bs.log('error', "unable to maintain session with web as error occures while sending request to wizdomweb");
			}
		});

	}

	prepareUrl(method: string, key:any) {
		if (key.toLowerCase( ) == 'test') {
			return this.bs.config.lmsBaseUrl.concat(method);
		}
		else if(key.toLowerCase( ) ==this.bs.config.storageSearchApiKey.toLowerCase()){
			return this.bs.config.searchApiEndpoint.concat("/" + method)
		}
		else {
			method = method.toLowerCase();
			//Changes for the time being for testing 
			//purposes of API V2 (async version of the following controllers)
			if (method.indexOf("fileupload/") > -1) {
				return this.bs.config.apiEndpoint.concat(method);
			}
			else {				
				return this.bs.config.apiEndpoint.concat("v2/" + method);
			}
		}
	}

	doPostWithPromise(storageKey:any, method:any, body: Object, hidePreLoader = false, extendSession = true) {
		//Don't extend session in case of Notification and Announcement referesh.		
		if (!hidePreLoader) {
			this.showPreloader();
		}
		if (extendSession) {
			if (this.chkSessionCntr > 60) {
				this.postExtendSessionRequest();
				this.chkSessionCntr = 0;
			}

		}


		return new Promise((resolve, reject) => {
			
			this.http.post(this.prepareUrl(method, storageKey), this.appendBaseParameters(body), this.appendHeaderIfUserLoggedIn()).toPromise().then(

				res => { // Success
					if (!hidePreLoader)
						this.hidePreloader();
					this.dataStore[storageKey] = res;
					//this.LastRequestTime = res['LastRequestTime'];
					resolve(this.dataStore[storageKey]);

				},
				msg => { // Error
					if (!hidePreLoader)
						this.hidePreloader();
					reject(msg);
					if (msg.status == '401') {
						this.bs.logout();
					}
				}
			);
		});
	};

	// get Data
	getData(storageKey:any, method:any, hidePreLoader = false, extendSession = true){
		return new Promise((resolve, reject) => {
			//Don't extend session in case of Notification and Announcement referesh.		
			if (!hidePreLoader) {
				this.showPreloader();
			}
			if (extendSession) {
				if (this.chkSessionCntr > 60) {
					this.postExtendSessionRequest();
					this.chkSessionCntr = 0;
				}

			}
			this.http.get(this.prepareUrl(method, storageKey)).toPromise().then(

				res => { // Success
					if (!hidePreLoader)
						this.hidePreloader();
					this.dataStore[storageKey] = res;
					//this.LastRequestTime = res['LastRequestTime'];
					resolve(this.dataStore[storageKey]);

				},
				msg => { // Error
					if (!hidePreLoader)
						this.hidePreloader();
					reject(msg);
					if (msg.status == '401') {
						this.bs.logout();
					}
				}
			);
		});
	}

	/*@TODO not used*/
	doPostWithObservable(storageKey:any, method:any, body:Object) {

		return new Promise((resolve, reject) => {
			this.http.post(this.bs.config.apiEndpoint.concat(method), body).subscribe(
				res => { // Success
					this.dataStore[storageKey] = res;
					resolve(this.dataStore[storageKey]);
				},
				msg => { // Error
					reject(msg);
				}
			);
		});
	};

	appendBaseParameters(params: Object|any) {

		if (this.dataStore.hasOwnProperty(this.bs.config.storageLoginKey)) {

			let loginClassParams = this.getDataStoreData(this.bs.config.storageLoginKey);
			params['CorporateId'] = loginClassParams['CorporateId'];
			params['Culture'] = loginClassParams['Culture'];
			params['UserId'] = loginClassParams['UserId'];
			params['TimeZoneValue'] = loginClassParams['TimeZoneValue'];
			params['EmailId'] = loginClassParams['EmailId'];
			params['UserRoles'] = loginClassParams['UserRoles'];
			params['AccessibleCategories'] = loginClassParams['AccessibleCategories'];
			params['UserRoleId'] = sessionStorage.getItem("selectedUserRoleID") == null ? 3 : sessionStorage.getItem("selectedUserRoleID");
			if (sessionStorage.getItem("selectedUserRoleID") != null) {
				this.bs.setUserAttr("SelectedUserRoleId", sessionStorage.getItem("selectedUserRoleID"));
			}
			if (sessionStorage.getItem("selectedCulture") != null) {
				params['Culture'] = sessionStorage.getItem("selectedCulture");
			}
			params['WebAppFlag'] = "W";
			params['LogOnCode'] = loginClassParams['LogOnCode'];
			
			if(loginClassParams['UserKey'])
				params['UserKey'] = loginClassParams['UserKey'];
			//params['LastRequestTime'] = this.LastRequestTime;
		}
		return params;
	}
}

